import { render, staticRenderFns } from "./Monitoring24JamIcuBalanceShiftView.vue?vue&type=template&id=38bbc1ae&scoped=true&"
import script from "./Monitoring24JamIcuBalanceShiftView.vue?vue&type=script&lang=ts&"
export * from "./Monitoring24JamIcuBalanceShiftView.vue?vue&type=script&lang=ts&"
import style0 from "./Monitoring24JamIcuBalanceShiftView.vue?vue&type=style&index=0&id=38bbc1ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bbc1ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VChip,VSimpleTable})
